module.exports = __webpack_public_path__ + "img/52636017ad1e3de18a7aee5f1bf2e6e1.png";